import { FabricApi } from '@repo/api-gw-sdk';
import type {
  Configuration,
  CreateFabricTableShortcutDemoRequest,
} from '@repo/api-gw-sdk';

export const integrations = (
  config: Configuration,
  currentProjectId: string
) => {
  const fabricApi = new FabricApi(config);

  return {
    fabric: {
      createTableShortcut: (request: CreateFabricTableShortcutDemoRequest) =>
        fabricApi.createFabricTableShortcutDemo(currentProjectId, request),
    },
  };
};
